// Logger Papicoo — debug/info no-op en production.
// Si window.Sentry est chargé (via CDN dans index.html), warn/error sont
// automatiquement forwardés à Sentry pour le monitoring temps réel.
const isDev = process.env.NODE_ENV !== "production";

const forwardToSentry = (level, args) => {
  try {
    if (typeof window !== "undefined" && window.Sentry && typeof window.Sentry.captureMessage === "function") {
      if (level === "error") {
        const err = args[0];
        if (err instanceof Error) window.Sentry.captureException(err, { extra: { args } });
        else window.Sentry.captureMessage(String(err || "error"), { level: "error", extra: { args } });
      } else {
        window.Sentry.captureMessage(String(args[0] || "warn"), { level: "warning", extra: { args } });
      }
    }
  } catch (e) {
    // Sentry échoue ne doit jamais casser l'app, mais on garde une trace console
    // pour qu'un dev puisse debug si Sentry est mal configuré.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[logger] Sentry forward failed:", e?.message || e);
    }
  }
};

export const debugLog = isDev ? (...args) => console.debug(...args) : () => {};
export const infoLog = isDev ? (...args) => console.info(...args) : () => {};
export const warn = (...args) => {
  console.warn(...args);
  forwardToSentry("warn", args);
};
export const error = (...args) => {
  console.error(...args);
  forwardToSentry("error", args);
};
